module.exports = __webpack_public_path__ + "static/media/planol-sync.46f4001c.jpg";